import React from 'react';
import { Col, Row } from 'react-flexbox-grid';
import { useNavigate } from 'react-router-dom';
import { Button, Module, ModuleBody, ModuleHeader } from '@wfp/ui';

import { type  Edition, type EditionDef, EditionState } from '../../restapi/types';
import { SectionSummary } from './SectionSummary';
import { allSectionForSummary, isRevision } from '../../restapi/document';
import { formatDate, formatHour } from '../../utils';
import { CreateRevision } from './CreateRevision';

import './EditionSummary.scss';


interface Props {
	def: EditionDef;
	edition?: Edition;
	notInHome?: boolean;
	nextRevision?: string;
}

function previewPdf(id = 0) {
	const url = `${import.meta.env.VITE_REST_API_BASE_URL}../../pdf/?edition_id=${id}`;
	window.open(url, 'DOB Preview PDF');
}

export function EditionSummary({edition: e, def: d, nextRevision, notInHome}: Props) {
	const sections = e && allSectionForSummary(e);

	const navigate = useNavigate();
	const isRev = isRevision(d);

	if (isRev && !e) {
		// an empty slot for a possible future revision
		return (d.name === nextRevision) ? <CreateRevision/> : null;
	}

	const isPdf = isRev || e?.name === '3rd';
	const preview = () => isPdf ? previewPdf(e?.id) : navigate(`/preview/${e?.id}`);

	return (
		<div className={`edition ${!e && 'empty'} ${e?.state} ${!notInHome && 'in-home'}`}>
			<Module>
				{d && <ModuleHeader>
					<Row between="xs" middle="xs">
						<Col xs>
							<div className="title">
								{isRev ?
									e?.name.replace('Rv', 'Revision ')
									: `${e?.name || d.name} Edition`
								}
							</div>
							{e?.issue?.sent ?
								<p className="mt note">Email sent</p>
								: e?.issue?.scheduledSend ?
									<p className="mt note">
										Send
										at <strong>{formatHour(e.issue.scheduledSend)}</strong> on {formatDate(e.issue.scheduledSend, true).substr(4)}
									</p>
									: null}

						</Col>
						{e && <Col xs className="col-fit-content">
							<Button kind="secondary" onClick={preview}>
								{e.state === EditionState.published ? 'View' : 'Preview'}
							</Button>
						</Col>}
					</Row>
				</ModuleHeader>}
				<ModuleBody>
					{sections ?
						sections.length ?
							<table className="edition-summary">
								{sections.map(s =>
									<SectionSummary key={s.id} section={s}/>,
								)}
							</table>
							: <p className="no-section-msg">No section</p>
						: <p>No section</p>
					}
				</ModuleBody>
			</Module>
		</div>
	);
}